import { Typography, styled } from "@mui/material";
import { FC } from "react";

import { pluralize } from "../../lib/Util";

interface CountDisplayProps {
  count: number;
  entity: string;
  testLabel?: string;
  sticky?: boolean;
}

const CountDisplayContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "sticky",
})<{ sticky: boolean }>(({ theme, sticky }) => ({
  display: "flex",
  justifyContent: "flex-end",
  flexDirection: "row",
  padding: theme.spacing(1),
  width: "100%",
  height: "50px",
  ...(sticky && { position: "sticky" }),
  top: "-12px",
  backgroundColor: sticky ? theme.palette.text10.main : "none",
  zIndex: 1,
}));

export const CountDisplay: FC<CountDisplayProps> = ({ count, entity, testLabel, sticky = false }) => (
  <CountDisplayContainer sticky={sticky}>
    <Typography sx={{ color: "text40.main", fontSize: 12 }} data-cy={testLabel}>
      Displaying <strong>{count}</strong> {pluralize(entity, count)}
    </Typography>
  </CountDisplayContainer>
);
